import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useColors } from '@osmosis/react-ui/hooks/useColors';
import { Flex } from '@osmosis/tailwind-ui/components/Box';
import { H2 } from '@osmosis/react-ui/components/Text';
import { P } from '@osmosis/react-ui/components/Text';
import { Deal } from '../../types/plans';
import moment from 'moment';

type Props = {
  deal?: Deal;
};

/**
 *ExpiredDealBanner.
 */
const ExpiredDealBanner: React.FC<Props> = ({ deal }): JSX.Element => {
  const { starts, expires } = deal || {};
  const colors = useColors();

  return (
    <Flex
      className={`bg-wp-red m-4 mx-10 mb-8 w-11/12 max-w-full flex-col justify-center rounded-lg p-6`}
    >
      <H2 color={colors.white} fontStyle="bold">
        <FormattedMessage
          id="plans.expired.deal.banner.title"
          defaultMessage="This deal is currently inactive"
        />
      </H2>
      {starts && expires ? (
        <P color={colors.white} fontSize="16px">
          <FormattedMessage
            id="plans.expired.deal.banner.period"
            defaultMessage="Activation period ({startDate} - {endDate})"
            values={{
              startDate: moment(starts).format('MM/DD/YYYY'),
              endDate: moment(expires).format('MM/DD/YYYY'),
            }}
          />
        </P>
      ) : null}
    </Flex>
  );
};
export default ExpiredDealBanner;
